/**
 * A transient failure is a network blip or a 5xx from the API (for example a
 * momentary DB lock timing out server-side). The invite itself is still valid,
 * so the query retries instead of telling the candidate their link is dead. A
 * 4xx (expired or unknown slug) is genuine and must not be retried.
 *
 * The status is read from the message thrown by `errorMiddleware`, which
 * formats non-ok responses as `HTTP <status>: <statusText>`.
 */
export const isTransientInviteError = (error: unknown): boolean => {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return true;
  }

  const message = error instanceof Error ? error.message : '';

  return (
    message.includes('Network Error') ||
    message.includes('Failed to fetch') ||
    /HTTP 5\d{2}\b/.test(message)
  );
};
